export enum UnitEnum {
    VOLUM = 'VOLUM',
    CURRENCY = 'CURRENCY',
    TIME = 'TIME',
}
